import { createContext, useContext } from 'react';
import { DropEvent, DropzoneOptions, FileRejection } from 'react-dropzone';

interface UploadAreaContextProps {
  submitHandler: (e: React.FormEvent<HTMLFormElement>) => void;
  onUrlPaste: (url: string) => void;
  onDrop: <T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void;
  mediaType: CF.UI.UISupportedUploadTypes;
  dropzoneOptions?: DropzoneOptions;
  textValue: string;
  onTextChange: (e: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const EMPTY_FUNC = (): boolean => false;

const initialValue: UploadAreaContextProps = {
  submitHandler: EMPTY_FUNC,
  onUrlPaste: EMPTY_FUNC,
  onDrop: EMPTY_FUNC,
  mediaType: 'text',
  textValue: '',
  onTextChange: EMPTY_FUNC,
};

export const UploadAreaContext = createContext(initialValue);

export const useUploadAreaContext = (): UploadAreaContextProps => useContext(UploadAreaContext);
